import { effect, signal } from '@preact/signals';
import type { ModeId } from '@vm/shared';
import { readJson, writeLocal } from '../api/http';

/** Remembered menu choices (per device). */
export interface MenuPrefs {
  /** Mode the lobby PLAY button starts. */
  mode: ModeId;
  /** Preferred map per mode for quick play ('' = any). */
  maps: Partial<Record<ModeId, string>>;
  practice: { mode: ModeId; mapId: string; bots: number; skill: number };
  room: { mode: ModeId; mapId: string; maxPlayers: number; bots: number; botSkill: number; timeLimit: number; scoreLimit: number; public: boolean };
  /** Day (YYYY-MM-DD) the daily login popup was last shown automatically. */
  dailyShown: string;
  /** Last seen MOTD so it only pops once. */
  seenMotd: string;
}

const DEFAULTS: MenuPrefs = {
  mode: 'tdm',
  maps: {},
  practice: { mode: 'tdm', mapId: 'brick_plaza', bots: 7, skill: 0.5 },
  room: { mode: 'tdm', mapId: 'brick_plaza', maxPlayers: 12, bots: 6, botSkill: 0.5, timeLimit: 480, scoreLimit: 50, public: false },
  dailyShown: '',
  seenMotd: '',
};

function load(): MenuPrefs {
  const saved = readJson<Partial<MenuPrefs>>('vm.prefs') ?? {};
  return {
    ...DEFAULTS,
    ...saved,
    practice: { ...DEFAULTS.practice, ...(saved.practice ?? {}) },
    room: { ...DEFAULTS.room, ...(saved.room ?? {}) },
    maps: { ...(saved.maps ?? {}) },
  };
}

export const prefs = signal<MenuPrefs>(load());

effect(() => {
  writeLocal('vm.prefs', JSON.stringify(prefs.value));
});

export function updatePrefs(patch: Partial<MenuPrefs>): void {
  prefs.value = { ...prefs.value, ...patch };
}
